import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dialog from '@mui/material/Dialog';
import { clearCategoryTree, categoryUpdateMemberPrice, categoryUpdateMemberPriceReset } from 'actions/EntityActions';
import { clearFormInput } from 'actions/FormActions';
import { showError } from 'actions/CommonActions';
// Basic Components
import CheckInput from 'screens/components/basic/CheckInput';
import DecimalInput from 'screens/components/basic/DecimalInput';
import CardSimple from 'screens/components/basic/CardSimple';
import Button from 'screens/components/basic/Button';

import CategoryUpdateMemberPriceHistoryList from './CategoryUpdateMemberPriceHistoryList';
import { DialogInput } from 'screens/components/advanced';
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';

class CategoryUpdateMemberPriceDialog extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      isOpen: false,
      accessoryTree: [],
      cannabisTree: [],
      confirmCategoryUpdateMemberPriceHistoryDialog: false,
      confirmOneCategoryUpdateMemberPriceHistoryDialog: false,
      selectedCategoryId: 0
    };
  }

  componentWillMount() {
    this.setState({ isOpen: this.props.isOpen });
  }

  componentWillUnmount() {
    this.clearPercentages();
  }

  componentWillReceiveProps(newProps) {
    if (this.state.isOpen !== newProps.isOpen) {
      this.setState({ isOpen: newProps.isOpen });
    }
    if (newProps.categoryTree && ((newProps.categoryTree.cannabis && newProps.categoryTree.cannabis.length > 0) || (newProps.categoryTree.accessory && newProps.categoryTree.accessory.length > 0)) && newProps.categoryTree != this.props.categoryTree) {
      let accessArray = [];
      let cannaArray = [];

      newProps.categoryTree.accessory.map((item) => {
        accessArray.push({
          id: item.id.toString(),
          title: item.name
        });
      });
      newProps.categoryTree.cannabis.map((item) => {
        cannaArray.push({
          id: item.id.toString(),
          title: item.name
        })
      })
      this.setState({
        accessoryTree: accessArray,
        cannabisTree: cannaArray
      })
    }
    if (newProps.updatedCount != 0 && newProps.updatedCount != this.props.updatedCount) {
      this.props.showError(newProps.updatedCount + " product member prices updated");
      this.props.categoryUpdateMemberPriceReset();
    }
  }

  clearPercentages = () => {
    let list = [];
    Object.keys(this.props.form).map(item => { if (item.indexOf("MemberCategoryMargin") >= 0) list.push(item) });
    list.map(item => { this.props.clearFormInput(item); });
  }

  resetAllCheckboxes = () => {
    let list = [];
    Object.keys(this.props.form).map(item => { if (item.indexOf("MemberCategoryId") >= 0) list.push(item) });
    list.map(item => { this.props.clearFormInput(item); });
  }

  openCategoryBulkUpdateMemberPriceHistoryDialog = () => {
    this.setState({ confirmCategoryUpdateMemberPriceHistoryDialog: true, confirmOneCategoryUpdateMemberPriceHistoryDialog: false, selectedCategoryId: 0 });
  }

  openOneCategoryBulkUpdateMemberPriceHistoryDialog = (categoryId) => {
    this.setState({ confirmCategoryUpdateMemberPriceHistoryDialog: false, confirmOneCategoryUpdateMemberPriceHistoryDialog: true, selectedCategoryId: categoryId });
  }

  categoryUpdateMemberPriceHistoryCancel = () => {
    this.setState({ confirmCategoryUpdateMemberPriceHistoryDialog: false, confirmOneCategoryUpdateMemberPriceHistoryDialog: false, selectedCategoryId: 0 });
  }

  getList = () => {
    let list = [];
    Object.keys(this.props.form).map(item => { if (item.indexOf("MemberCategoryId") >= 0) list.push(item) });
    if (list.length == 0) { this.props.showError("Please select a Category and set the Percentage Discount"); return []; }
    let cats = [];
    let missing = [];
    list.map(item => {
      if (this.props.form[item]) if (this.props.form[`MemberCategoryMargin${item.substring(16)}`])
        cats.push({ id: item.substring(16), margin: this.props.form[`MemberCategoryMargin${item.substring(16)}`] });
      else { missing.push(this.state.cannabisTree.concat(this.state.accessoryTree).find(x => x.id == Number(item.substring(16))).title); }
    });
    if (missing.length != 0) { this.props.showError("Please enter Percentage Discount for: " + missing.join(", ")); return []; }
    return cats;
  }

  normalUpdate = () => {
    let cats = this.getList();
    if (cats.length == 0) return;
    let model = {
      margins: cats, branchId: this.props.branchId, mode: 1
    }
    this.props.categoryUpdateMemberPrice(model);
    this.resetAllCheckboxes();
  }

  aggressiveUpdate = () => {
    let cats = this.getList();
    if (cats.length == 0) return;
    let model = {
      margins: cats, branchId: this.props.branchId, mode: 2
    }
    this.props.categoryUpdateMemberPrice(model);
    this.resetAllCheckboxes();
  }

  closeDialog = () => {
    this.setState({ isOpen: false });
    this.props.clearCategoryTree();
    this.props.onCancel();
  }

  confirm = () => {
    this.setState({ isOpen: false });
    this.props.onConfirm();
  }

  render() {
    const s = this.state;
    let treeStyle = "myCls halfTree";

    return (
      <DialogInput
        title={<DialogHeaderWithClose text={"Update Member Prices By Category"} classicClass="posDialogClassic" handleClose={() => this.props.onCancel()} />}
        titleStyle={{ textAlign: "center", paddingBottom: `0px` }}
        modal={true}
        open={s.isOpen}
        scrollable={true}
        contentStyle={{
          maxheight: '650px',
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)'
        }}>
        <CardSimple style={{ padding: `10px` }}>
          <div className="row">
            <div className="col-xs-12 col-sm-5 col-md-5 col-lg-5 col-xl-5 pt-2" >
              <Button

                type="RaisedButton"
                name="normalButton"
                className="btn-space mb-1"
                label="Run Normal Mode"
                backgroundColor={"#5D1A80"}
                onTouchTap={() => this.normalUpdate()} /><br />
              <Button
                type="RaisedButton"
                name="aggressiveButton"
                className="btn-space mb-2"
                label="Run Aggressive Mode"
                backgroundColor={"#5D1A80"}
                onTouchTap={() => this.aggressiveUpdate()} />
              <Button
                type="SaveButtonNoIcon"
                name="showHistoryButton"
                label="All History"
                className="btn-space mb-1"
                onTouchTap={() => this.openCategoryBulkUpdateMemberPriceHistoryDialog()}
              />
            </div>
            <div className="col-xs-12 col-sm-7 col-md-7 col-lg-7 col-xl-7 pl-auto" style={{ color: "red", fontSize: `12px` }}>
              *This feature will update Member Prices per Category (by discount %), based on the current selling price of each product. <br />
              *Normal Mode: will only affect products with no discounts set.<br />
              *Aggressive Mode: will overwrite all products.<br />
              Member Prices will be rounded to the nearest $0.49 or $0.99.<h5 style={{ color: "red", fontSize: `12px` }}>Updates cannot be reverted</h5><br />
            </div>

            <div className="row pb-2 pl-2" style={{ overflowY: `scroll`, overflowX: `hidden`, maxHeight: `450px` }}>
              <h3>Cannabis</h3>
              {this.state.cannabisTree.length && this.state.cannabisTree.sort((a, b) => a.title.toLowerCase() > b.title.toLowerCase() ? 1 : -1).map((t, index) => {
                let oneCategory = (
                  <div className="container-fluid" >
                    <div className='row'>
                      <div className="col-xs-4 col-sm-4 col-md-3 col-lg-3 col-xl-3 pt-2 mb-0 pb-0" style={{ height: `40px` }}>
                        <CheckInput id={`checkCategory-${index}`} name={`MemberCategoryId${t.id}`} text={t.title} labelStyle={{ fontWeight: 700 }}
                          containerStyle={{ paddingTop: '0' }} />
                      </div>
                      <div className="col-xs-5 col-sm-5 col-md-5 col-lg-5 col-xl-5 pt-0 mb-0 pb-0" style={{ height: `40px` }}>
                        <DecimalInput id={`inputCategoryPercent-${index}`} name={`MemberCategoryMargin${t.id}`} floatingLabelText="Percentage Discount(%)" />
                      </div>
                      <div className="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 pt-0 mb-0 pb-0" >
                        <Button
                          type="EditButton"
                          name={`butShowHistory${t.id}`}
                          label="History"
                          className="primary-color-bg space vertical-space"
                          onTouchTap={() => this.openOneCategoryBulkUpdateMemberPriceHistoryDialog(t.id)}
                        />
                      </div>
                    </div>
                    <hr />
                  </div>);
                return (oneCategory);
              })
              }
              <br /><br />
              <h3>Accessories</h3>
              {this.state.accessoryTree.length && this.state.accessoryTree.sort((a, b) => a.title.toLowerCase() > b.title.toLowerCase() ? 1 : -1).map((t, index) => {
                let oneCategory = (
                  <div className="container-fluid">
                    <div className='row'>
                      <div className="col-xs-4 col-sm-4 col-md-3 col-lg-3 col-xl-3 pt-2 mb-0 pb-0 mt-auto" style={{ height: `40px` }}>
                        <CheckInput name={`MemberCategoryId${t.id}`} text={t.title} />
                      </div>
                      <div className="col-xs-5 col-sm-5 col-md-5 col-lg-5 col-xl-5 pt-0 mb-0 pb-0" style={{ height: `40px` }}>
                        <DecimalInput name={`MemberCategoryMargin${t.id}`} floatingLabelText="Percentage Discount(%)" />
                      </div>
                      <div className="col-xs-3 col-sm-3 col-md-4 col-lg-4 col-xl-4 pt-0 mb-0 pb-0" style={{ height: `40px` }}>
                        <Button
                          type="SaveButtonNoIcon"
                          name={`butShowHistory${t.id}`}
                          label="History"
                          className="primary-color-bg space vertical-space"
                          onTouchTap={() => this.openOneCategoryBulkUpdateMemberPriceHistoryDialog(t.id)}
                        />
                      </div>
                    </div>  
                    <hr />
                  </div>);
                return (oneCategory);
              })
              }
            </div>
          </div>
          <div style={{ paddingBottom: `40px` }}>
            <Button
              name="DoneButton"
              className="pull-right mt-2"
              label="CLOSE"
              primary={true}
              onTouchTap={() => this.props.onCancel()} />
          </div>
        </CardSimple>
        <CategoryUpdateMemberPriceHistoryList
          isOpen={this.state.confirmCategoryUpdateMemberPriceHistoryDialog || this.state.confirmOneCategoryUpdateMemberPriceHistoryDialog}
          allCategory={this.state.confirmCategoryUpdateMemberPriceHistoryDialog}
          oneCategory={this.state.confirmOneCategoryUpdateMemberPriceHistoryDialog}
          onCancel={this.categoryUpdateMemberPriceHistoryCancel}
          categoryId={this.state.selectedCategoryId}
        />
      </DialogInput>
    );
  }
}

function mapStatetoProps(state) {
  return {
    categoryTree: state.entity.categoryTree || [],
    form: state.form || [],
    allBranches: state.form[`MemberCategoryAllBranches`],
    branchId: state.common.branchId,
    updatedCount: state.entity.categoryMemberPriceUpdateCount
  };
}

function mapDispatchToProps(dispatch) {
  return {
    clearCategoryTree: () => dispatch(clearCategoryTree()),
    categoryUpdateMemberPrice: (model) => dispatch(categoryUpdateMemberPrice(model)),
    showError: (message) => dispatch(showError(message)),
    categoryUpdateMemberPriceReset: () => dispatch(categoryUpdateMemberPriceReset()),
    clearFormInput: (name) => dispatch(clearFormInput(name))
  };
}

export default connect(mapStatetoProps, mapDispatchToProps)(CategoryUpdateMemberPriceDialog);